import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase-client";
import { Plus, Pencil, CircleX, ArrowLeft } from "lucide-react";

export default function Usuarios() {
   const [tasks, setTasks] = useState([]);
   // const [selectedCod, setSelectedCod] = useState("");
   const [usuarios, setUsuarios] = useState([]);
   // const [imagenes, setImagenes] = useState([]);
   const [change, setChange] = useState(false);
   // var imageindx = 0;

   const fetchUsuarios = async () => {
      const { error, data } = await supabase
         .from("usuarios")
         .select(`
            id,
            documento,
            nombre,
            email,
            celular,
            perfil,
            tabla (id,descripcion)
            `)
         .order("created_at", { ascending: true });

      if (error) {
         console.error("Error reading usuario: ", error.message);
         return;
      }

      setUsuarios(data);
   };
   
   const fetchTasks = async () => {
      const { error, data } = await supabase
         .from("tabla")
         .select("*")
         .eq("cod", 4)
         .gt("orden", 1)
         .order("created_at", { ascending: true });

      if (error) {
         console.error("Error reading task: ", error.message);
         return;
      }

      setTasks(data);
   };

   useEffect(() => {
      fetchUsuarios();
      fetchTasks()
   }, [change]);

   console.log("data: ", usuarios);

   const [editRecord, setEditRecord] = useState(null);

   const handleSave = async () => {

      console.log("editRecord: ", editRecord);
      if (!editRecord.id) {
         const { error } = await supabase.from("users").insert(editRecord);
         if (error) {
            console.log("error ", error);
            alert(error.message);
            return;
         }
         setChange(!change);
      } else {
         const { error } = await supabase
            .from("users")
            .update({
               nombre: editRecord.nombre,
               email: editRecord.email,
               perfil: editRecord.perfil,
            })
            .eq("id", editRecord.id);

         if (error) {
            console.log("error ", error);
            alert(error.message);
            return;
         }
         setChange(!change);
      }
      setEditRecord(null);
   };


   const handleDelete = async (id) => {
      const { error } = await supabase.from("usuario").delete().eq("id", id);

      if (error) {
         console.log("error ", error);
         alert(error.message);
         return;
      }
      setChange(!change);
   };

    console.log("tasks: ", tasks);
   // console.log("imageRecord: ", imageRecord[0].texto);
   return (
      <div className="p-6 max-w-xl mx-auto">

         {/* Results Table */}
         <div className="mt-6">
            <div className="flex justify-between">
               <h2 className="text-lg font-semibold mb-3">Clientes:</h2>
               <button onClick={() => setEditRecord({})} className="btn-green">
                  <Plus className="lucid-icons-blue" /> Nuevo
               </button>
            </div>
            {usuarios && (
               <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
                  <thead className="bg-gray-200 text-gray-700">
                     <tr>
                        {/* <th className="p-2 text-left">ID</th> */}
                        <th className="p-2 text-left">Documento</th>
                        <th className="p-2 text-left">Nombre</th>
                        <th className="p-2 text-left">Email</th>
                        <th className="p-2 text-left">Telefono</th>
                        <th className="p-2 text-left">Perfil</th>
                        <th className="p-2 text-left">Acciones</th>
                     </tr>
                  </thead>
                  <tbody>
                     {usuarios.map((rec) => (
                        <tr key={rec.id} className="border-t hover:bg-gray-50">
                           {/* <td className="p-2">{rec.id}</td> */}
                           <td className="p-2">{rec.documento}</td>
                           <td className="p-2">{rec.nombre}</td>
                           <td className="p-2">{rec.email}</td>
                           <td className="p-2">{rec.celular}</td>
                           <td className="p-2">{rec.tabla.descripcion}</td>
                           <td className="p-2 flex gap-2">
                              <button
                                 onClick={() => setEditRecord({ ...rec })}
                                 className="btn-green"
                              >
                                 <Pencil className="lucid-icons-blue" /> Editar
                              </button>
                              <button
                                 onClick={() => handleDelete(rec.id)}
                                 className="btn-red"
                              >
                                 <CircleX className="lucid-icons-red" /> Borrar
                              </button>
                           </td>
                        </tr>
                     ))}
                  </tbody>
               </table>
            )}
         </div>

         {/* Modal */}
         {editRecord && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
               <div className="bg-white p-6 rounded-lg shadow-lg w-2/4">
                  <h2 className="text-xl font-bold mb-4">Editar Registro</h2>
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700  p-2 w-48">
                        Documento
                     </label>
                     <input
                        type="text"
                        className="w-full p-2 border rounded mb-4"
                        value={editRecord.documento}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              documento: e.target.value,
                           })
                        }
                     />
                  </div>
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700  p-2 w-48">
                        Nombre
                     </label>
                     <input
                        type="text"
                        className="w-full p-2 border rounded mb-4"
                        value={editRecord.nombre}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              nombre: e.target.value,
                           })
                        }
                     />
                  </div>
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Mail 
                     </label>
                     <input
                        className="w-full p-2 border rounded mb-4"
                        value={editRecord.email}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              email: e.target.value,
                           })
                        }
                     />
                  </div>
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Telefono 
                     </label>
                     <input
                        className="w-full p-2 border rounded mb-4"
                        value={editRecord.celular}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              celular: e.target.value,
                           })
                        }
                     />
                  </div>
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Perfil
                     </label>
                     <select
                        value={editRecord.perfil}
                        // onChange={(e) => onChange(e.target.value)}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              perfil: e.target.value,
                           })
                        }
                        className="block w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm 
                                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                                 sm:text-sm"
                     >
                        <option value="">Seleccione...</option>
                        {tasks.map((item) => (
                        <option key={item.id} value={item.id}>
                           {item.descripcion}
                        </option>
                        ))}
                     </select>                     
                  </div>
                  <div className="flex justify-end gap-3">
                     <button
                        onClick={() => setEditRecord(null)}
                        className="btn-gray-light"
                     >
                        <ArrowLeft className="lucid-icons" /> Volver
                     </button>
                     <button onClick={handleSave} className="btn-green">
                        <Plus className="lucid-icons-blue" /> Guardar
                     </button>
                  </div>
               </div>
            </div>
         )}


      </div>
   );
}
